'use strict';

import controller from './importacion-computos.controller';
import template from './importacion-computos.html';
import service  from '../integracion.service';

const ImportacionComputosComponent = {
    bindings: {
        item: '<',
        idsupervision: '<',
        computos :'=',
        resumen:'='
    },
    controller,
    template,
    service
    
};

export default ImportacionComputosComponent;


// WEBPACK FOOTER //
// ./src/app/components/integracion-siga/importacion-computos/importacion-computos.component.js